import {otsBaseApi} from "../../ots-api";
import {PipelineGraph} from "../../../model/pipeline/pipeline-graph";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["PipelineGraphs", "PipelinePipelineGraphs"]});

export const pipelineGraphApi = taggedBaseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllPipelineGraphs: builder.query<PipelineGraph[], string | undefined>({
            query: (regionId) => ({
                url: `/pipeline-graph/all`,
                method: "GET",
                params: removeUndefined({
                    regionId: regionId
                })
            }),
            keepUnusedDataFor: 300,
            providesTags: (result) => {
                if (result) {
                    return [
                        ...result.map(({id}) => ({type: "PipelineGraphs", id} as const)),
                        {type: "PipelineGraphs", id: "LIST"}
                    ];
                } else {
                    return [{type: "PipelineGraphs", id: "LIST"}];
                }
            }
        }),
        getPipelineGraphsByPipeline: builder.query<PipelineGraph[], string>({
            query: (pipelineId) => ({
                url: `/pipeline-graph/pipeline/${pipelineId}/all`,
                method: "GET",
            }),
            keepUnusedDataFor: 300,
            providesTags: (result, _error, arg, _meta) => {
                if (result) {
                    return [
                        ...result.map(
                            ({id}) => ({type: "PipelineGraphs", id} as const)
                        ),
                        {type: "PipelinePipelineGraphs", id: arg}
                    ];
                } else {
                    return [];
                }
            }
        }),
        getPipelineGraph: builder.query<PipelineGraph, string>({
            query: (id) => ({
                url: `/pipeline-graph/${id}`,
                method: "GET",
            }),
            providesTags: (result, error, id) => [{type: "PipelineGraphs", id}]
        }),
        createPipelineGraph: builder.mutation<PipelineGraph, Partial<PipelineGraph>>({
            query: (mapping) => ({
                url: "/pipeline-graph",
                method: "POST",
                body: mapping
            }),
            invalidatesTags: (_result, _error, {pipelineId}, _meta) => {
                return [
                    {type: "PipelineGraphs", id: "LIST"},
                    {type: "PipelinePipelineGraphs", id: pipelineId}
                ]
            }
        }),
        updatePipelineGraph: builder.mutation<PipelineGraph, Partial<PipelineGraph>>({
            query: (mapping) => ({
                url: "/pipeline-graph",
                method: "PUT",
                body: mapping,
            }),
            invalidatesTags: (_result, _error, {id, pipelineId}, _meta) => {
                return [
                    {type: "PipelineGraphs", id: id},
                    {type: "PipelineGraphs", id: "LIST"},
                    {type: "PipelinePipelineGraphs", id: pipelineId}
                ]
            }
        }),
        deletePipelineGraph: builder.mutation<void, Partial<PipelineGraph>>({
            query: (mapping) => ({
                url: "/pipeline-graph",
                method: "DELETE",
                body: mapping
            }),
            invalidatesTags: (_result, _error, {id, pipelineId}, _meta) => {
                return [
                    {type: "PipelineGraphs", id: id},
                    {type: "PipelineGraphs", id: "LIST"},
                    {type: "PipelinePipelineGraphs", id: pipelineId}
                ]
            }
        })
    })
});

export const {
    useGetAllPipelineGraphsQuery,
    useGetPipelineGraphsByPipelineQuery,
    useGetPipelineGraphQuery,
    useCreatePipelineGraphMutation,
    useUpdatePipelineGraphMutation,
    useDeletePipelineGraphMutation,
} = pipelineGraphApi;
